import _classCallCheck from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { EventTarget } from '../event-target';
import { CONTEXT_STORE } from '../globals';
import { wrapEventListener } from '../helpers/wrap-event-listener';
export var createMinimalBaseAudioContextConstructor = function createMinimalBaseAudioContextConstructor(audioDestinationNodeConstructor, createAudioListener) {
  return (
    /*#__PURE__*/
    function (_EventTarget) {
      _inherits(MinimalBaseAudioContext, _EventTarget);

      function MinimalBaseAudioContext(_nativeContext, numberOfChannels) {
        var _this;

        _classCallCheck(this, MinimalBaseAudioContext);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(MinimalBaseAudioContext).call(this, _nativeContext));
        _this._nativeContext = _nativeContext;
        CONTEXT_STORE.set(_assertThisInitialized(_this), _nativeContext); // Bug #93: Edge will set the sampleRate of an AudioContext to zero when it is closed.

        var sampleRate = _nativeContext.sampleRate;
        Object.defineProperty(_nativeContext, 'sampleRate', {
          get: function get() {
            return sampleRate;
          }
        });
        _this._destination = new audioDestinationNodeConstructor(_assertThisInitialized(_this), numberOfChannels);
        _this._listener = createAudioListener(_assertThisInitialized(_this), _nativeContext);
        _this._onstatechange = null;
        return _this;
      }

      _createClass(MinimalBaseAudioContext, [{
        key: "currentTime",
        get: function get() {
          return this._nativeContext.currentTime;
        }
      }, {
        key: "destination",
        get: function get() {
          return this._destination;
        }
      }, {
        key: "listener",
        get: function get() {
          return this._listener;
        }
      }, {
        key: "onstatechange",
        get: function get() {
          return this._onstatechange;
        },
        set: function set(value) {
          var wrappedListener = wrapEventListener(this, value);
          this._nativeContext.onstatechange = wrappedListener;
          var nativeOnStateChange = this._nativeContext.onstatechange;
          this._onstatechange = nativeOnStateChange === wrappedListener ? value : nativeOnStateChange;
        }
      }, {
        key: "sampleRate",
        get: function get() {
          return this._nativeContext.sampleRate;
        }
      }, {
        key: "state",
        get: function get() {
          return this._nativeContext.state;
        }
      }]);

      return MinimalBaseAudioContext;
    }(EventTarget)
  );
};